/* This file is autogenerated, see readme.md for instructions */
import SplitFlowSvgIcon from '@bloomreach/banana-theme/icons/split-flow.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SplitFlowIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SplitFlowSvgIcon />
    </Icon>
  );
});

SplitFlowIcon.displayName = 'SplitFlowIcon';

export default SplitFlowIcon;
